import { OccConfig } from '@spartacus/core';

export const pageOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        customPage: '/cms/pages/${id}',
      } as any,
    },
  },
};
